<div
    class="notification-details-block"
    (click)="onViewNotification($event)"
    [ngClass]="{
        'notification-details-block--read':
            notification.notificationStatusId == notificationStatuses.Read
    }">
    <div class="notification-details-block__profilepic">
        <img
            alt="User Picture"
            class="profilepic--round"
            src="{{ notification.insertedUser.profilePictureUri }}" />
    </div>
    <span
        class="notification-details-block__content"
        [innerHTML]="notification.message"></span>
    <span class="spacer"></span>
    <div class="notification-details-block__timestamp">
        <span class="timestamp--display">{{
            notification.insertedDate | relativeTime
        }}</span>
        <span
            (click)="toggleReadNotification($event)"
            class="timestamp-action--display"
            >Mark as
            {{
                notification.notificationStatusId == notificationStatuses.Unread
                    ? 'read'
                    : 'unread'
            }}
        </span>
    </div>
</div>
